<template>
	<div>
		<client-only>
			<component :is="tag"
					   v-html="computedTitle" />
		</client-only>
	</div>
</template>

<script setup>
const props = defineProps({
	data: {
		type: String,
		required: true
	},
	tag: {
		type: String,
		default: 'h1'
	}
})

const computedTitle = computed(() => {
	let output = props.data

	// Try DOMParser if available (browser, client side)
	if (typeof DOMParser !== 'undefined') {
		try {
			const parser = new DOMParser()
			const doc = parser.parseFromString(input, 'text/html')
			const firstElement = doc.body.firstElementChild
			if (firstElement) {
				output = firstElement.innerHTML
			}
		} catch (e) {
			// fallback below if parsing fails
		}
	} else {
		// Fallback regex (Node.js, serverside) → remove outermost tag
		output = input.replace(/^<[^>]+>([\s\S]*?)<\/[^>]+>$/, '$1')
	}

	// Replace <strong> & <b> with <span>
	output = output
		.replace(/<(strong|b)>/gi, '<span>')
		.replace(/<\/(strong|b)>/gi, '</span>')

	return output
})
</script>